// Local-date helpers. Deadlines and *Date stamps are local "YYYY-MM-DD"
// strings; parsing them as UTC would shift a day for anyone west of GMT.

const pad = (n) => String(n).padStart(2, "0");

// A Date → "YYYY-MM-DD", in local time.
export const toKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// "YYYY-MM-DD" → a local Date at midnight.
export const parseKey = (dateStr) => {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const todayKey = () => toKey(new Date());

// Days from today to dateStr: negative = overdue, 0 = today, null = no date.
export const daysUntil = (dateStr) => {
  if (!dateStr) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((parseKey(dateStr) - today) / (1000 * 60 * 60 * 24));
};
